import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Icon } from "../../lib/icon";
import { StaggerItem } from "../common/Reveal";

export default function ServiceCard({ service }) {
  return (
    <StaggerItem className={service.span || ""}>
      <Link
        to={`/services/${service.slug}`}
        className="group relative flex h-full min-h-[240px] flex-col justify-between overflow-hidden rounded-2xl border border-white/10 bg-ink-800/60 p-8 transition-colors duration-500 hover:border-sky-400/40"
        data-testid={`service-card-${service.slug}`}
      >
        <div
          className="pointer-events-none absolute inset-0 bg-cover bg-center opacity-0 transition-opacity duration-700 group-hover:opacity-[0.18]"
          style={{ backgroundImage: `url(${service.image})` }}
          aria-hidden="true"
        />
        <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-sky-500/10 blur-3xl transition-opacity duration-500 group-hover:bg-sky-500/20" />

        <div className="relative">
          <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-sky-400 transition-colors duration-500 group-hover:border-sky-400/50 group-hover:text-sky-300">
            <Icon name={service.icon} className="h-6 w-6" />
          </div>
          <h3 className="font-heading text-xl font-bold tracking-tight text-white lg:text-2xl">
            {service.name}
          </h3>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-slate-400">
            {service.description}
          </p>
        </div>

        <div className="relative mt-6 inline-flex items-center gap-2 text-sm font-medium text-sky-400">
          Learn More
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </div>
      </Link>
    </StaggerItem>
  );
}
